import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import CancelIcon from '@material-ui/icons/Cancel';
import IconButton from '@material-ui/core/IconButton';

import AutoAllocationFilters from './AutoAllocationFilters';
import AutoAllocationContent from './AutoAllocateContent';

export default function AutoAllocatePage({ onClose }) {
  document.title = 'AutoAllocate Logs';

  const orgUnitId = useSelector(store => store.areas.dailyPlanning.filters.selectedTeam);
  const selectedDate = useSelector(store => store.areas.dailyPlanning.selectedDate);
  const isNightMode = useSelector(store => store.areas.dailyPlanning.scheduler.isNightMode);

  const [state, setState] = useState({
    orgUnitId,
    selectedDate,
    isNightMode,
    logType: -1,
    groupId: null,
  });

  const headerRender = () => {
    return (
      <div className="sidePanel-header form-header">
        <div className="sidePanel-header-subtitle">
          <Box display="flex">
            <Box flexGrow={1} py={1}>
              <Typography variant="subtitle1">AutoAllocation Monitor</Typography>
            </Box>
            <Box>
              <IconButton onClick={onClose}>
                <CancelIcon />
              </IconButton>
            </Box>
          </Box>
        </div>
      </div>
    );
  };

  const contentRender = () => {
    return (
      <React.Fragment>
        <AutoAllocationFilters
          onSubmit={filtersState => setState(filtersState)}
          onClose={onClose}
          defaultModel={state}
        />
        <AutoAllocationContent {...state} />
      </React.Fragment>
    );
  };

  return (
    <section className="side-panel-content-wrapper">
      <SwipeableDrawer
        anchor="right"
        open
        onOpen={() => {}}
        onClose={onClose}
        ModalProps={{
          onBackdropClick: onClose,
        }}
      >
        {headerRender()}
        {contentRender()}
      </SwipeableDrawer>
    </section>
  );
}
